import { BehaviorSubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  isHttpRequest = new BehaviorSubject<boolean>(false);
  isLoading = new Subject<boolean>();
  LoadArr:boolean[] = [];

  constructor() {
    // Delay the LoadStart call to avoid potential injection context issues
    setTimeout(() => {
      this.LoadStart();
    }, 0);
   }

  LoadStart(){
    this.isLoading.subscribe((loading)=>{
      if(loading == true){
        this.LoadArr.push(loading);
      }else{
          this.LoadArr.pop();
      }
    })
  }

}
